<template>
    <div>
        <menu-bar></menu-bar>

        <div class="container" role="main">
            <div class="row" style="margin-top: 50px">

                <ol class="breadcrumb">
                    <li><a href="#/">INICIAL</a></li>
                    <li class="active">BUSCAR CONTRATO</li>
                </ol>

                <div class="row">
                    <div class="col-md-12">

                        <form class="form-horizontal">

                            <div class="panel panel-info">
                                <div class="panel-heading">BUSCA DE CONTRATO</div>
                                <div class="panel-body">

                                    <div class="form-group">
                                        <div class="col-sm-4">
                                            <label for="link_total" class="control-label">MAC</label>
                                            <input id="link_total" v-model="mac" class="form-control"><br/>
                                            <button :disabled="! mac" @click.stop.prevent="buscar()" class="btn btn-success">
                                                BUSCAR CONTRATO
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </form>

                        <table v-if="contrato" id="mytable" class="table table-bordred table-striped">

                            <thead>

                                <tr>
                                    <th>CLIENTE</th>
                                    <th style="text-align: center;width: 100px">IP</th>
                                    <th style="width: 100px"></th>
                                </tr>

                            </thead>

                            <tbody>

                                <tr>
                                    <td>{{ contrato.cliente.nome }}</td>
                                    <td class="text-center">{{ contrato.radio.ip }}</td>
                                    <td style="text-align: center">
                                        <a :href="'#/contrato/add/' + contrato._id" class="btn btn-primary btn-xs">
                                            ABRIR <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                                        </a>
                                    </td>
                                </tr>

                            </tbody>

                        </table>

                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Contratos } from "../../class/index";
import ComboMeses from "../../components/combo/meses";
import ComboAnos from "../../components/combo/anos";
import { date } from "../../filters";
export default {
    name: "BuscaClienteIpv6",
    components: {
        ComboMeses,
        ComboAnos
    },
    filters: {
        date
    },
    data() {
        return {
            mac: null,
            mes: null,
            ano: null,
            contrato: null
        };
    },
    methods: {
        async buscar() {
            this.contrato = await Contratos.byMac(this.mac);
        }
    }
};
</script>

<style scoped>
</style>
